const app = require('./app.js')
const loadingCircle = require('./ui.loadingCircle.js')
const { Template } = require('./ui.template.js')
const imagePlayer = require('./ui.imagePlayer.js')

class timeline extends Template {
    dataType = 'cast'
    wsName = 'getCastsForDevice'

    init(device_id) {
        this.device_id = device_id
        this.wsName = 'getCastsForDevice'
        this.itemsPerFetch = 75
        app.webSocket.sendMessage({ type: this.wsName, device_id: this.device_id, from: 0, to: this.itemsPerFetch })
        //this.playCast = this.playCast.bind(this);
    }

    playCast(data) {
        const ui = require('./ui.js')
        app.webSocket.sendMessage({ type: 'playCast', cast_id: data.id })
        ui.views['player'] = new imagePlayer([], data, (id) => {
            app.webSocket.sendMessage({ type: 'stopCast', cast_id: id })
        })
    }

    clickEvent = this.playCast
}

module.exports = timeline
